<template>
  <grid
    :model="getModel"
    name='Invoice Scanning'
    desc='Line Item Entry'
    search-placeholder='Invoices to be scanned'
    fit-columns
    :search="true"
    :resizing="false"
    footer
    :endpoint='api.$.admin.getInvoicesToBeScanned'
    alias='InvoiceScanQueue'
    :tabs='tabs'
    ref='ScanInvoiceGrid'
  >
    <back slot="back-action"/>

    <span slot="additionalButtons">
      <ed-button
        class="btn btn-actionbar"
        :disabled='disableScanInvoiceButton'
        @click="scanInvoice(paymentInvoiceId)"
        name='scan_invoice_button'>
        Scan Invoice
      </ed-button>
      <ed-button
        class="btn btn-actionbar"
        :disabled='disableReviewButton'
        @click="reviewInvoice(paymentInvoiceId)"
        name='review_invoice_button'>
        Review
      </ed-button>
    </span>
  </grid>
</template>

<script>

import Grid from '@/components/Grid'
import ScanInvoiceModel from './models/scan-invoice-model.js'
import { EventBus, Eved } from '@/event-bus'
import tabs from './tabs'
import back from './Components/back'

export default {
  components: {
    Grid,
    back
  },

  data () {
    return {
      ScanInvoiceModel,
      paymentInvoiceId: 0,
      disableScanInvoiceButton: true,
      disableReviewButton: true,
      tabs: tabs.tabs
    }
  },

  created() {
    // handle Edit Button availability
    EventBus.$off(Eved.GENERIC.SELECTED_ITEM).$on(Eved.GENERIC.SELECTED_ITEM, r => {
      this.handleButtons(r)
    })
    EventBus.$off(Eved.GENERIC.UNSELECTED_ITEM).$on(Eved.GENERIC.UNSELECTED_ITEM, r => {
      this.handleButtons(r)
    })
    EventBus.$off(Eved.GENERIC.SELECTED_ALL).$on(Eved.GENERIC.SELECTED_ALL, r => {
      this.handleButtons(r)
    })
    EventBus.$off(Eved.GENERIC.UNSELECTED_ALL).$on(Eved.GENERIC.UNSELECTED_ALL, r => {
      this.handleButtons(r)
    })
  },

  computed: {
    getModel() {
      return ScanInvoiceModel.get()
    }
  },

  methods: {
    scanInvoice(paymentInvoiceId) {
      this.api.post(this.api.$.admin.scannerIsAssignedToInvoice, {
        paymentInvoiceId: paymentInvoiceId,
        scannerId: global.app.$user.$.user.UserID
      }).then(r => {
        if (r.data) {
          alert('The invoice has already been assigned')
        } else {
          this.refresh()
          // Redirect to Upload Invoice PAGE
          this.$router.push('/d/Invoice/upload?invoiceId=' + paymentInvoiceId + '&from=eoadmin')
          // this.redirectToUploadInvoicePage(paymentInvoiceId)
        }
      })
    },

    reviewInvoice(paymentInvoiceId) {
      this.api.post(this.api.$.admin.validateReviewInvoiceAction, {
        paymentInvoiceId: paymentInvoiceId,
        reviewerUserId: global.app.$user.$.user.UserID
      }).then(r => {
        if ((r.data || '') !== '') {
          global.app.$notifications.notify({
            alert: true,
            type: 'plain',
            icon: 'exclamation-circle',
            placement: { from: 'top', align: 'center' },
            timeout: 0,
            message: r.data
          })
        } else {
          this.refresh()
          this.$router.push('/d/Invoice/upload?invoiceId=' + paymentInvoiceId + '&from=eoadmin')
        }
      })
    },

    redirectToUploadInvoicePage(paymentInvoiceId) {
      window.location.reload(this.$router.replace('/d/InvoiceToPay/upload?invoiceId=' + paymentInvoiceId))
    },

    refresh() {
      this.$refs.ScanInvoiceGrid.quickSearch()
      this.$refs.ScanInvoiceGrid.onSelectAll(false)
    },

    handleButtons(r) {
      if (r && r.data && r.data.length === 1) {
        this.enableButtons(false)
        this.paymentInvoiceId = r.data[0].PaymentInvoiceId
      } else {
        this.enableButtons(true)
        this.paymentInvoiceId = 0
      }
    },

    enableButtons(state) {
      this.disableScanInvoiceButton = state
      this.disableReviewButton = state
    }
  },

  beforeDestroy() {
    EventBus.$emit(Eved.GENERIC.UNSELECTED_ALL)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/InvoiceScan/Queue.vue